import debounce from './debounce';

function registerBanner() {
  const setBanner = () => {
    if (!document.body.classList.contains('App\\RegisterPage')) {
      return;
    }

    const e = window.matchMedia('(max-width: 991px)');
    const bannerContent = document.querySelector('.register-banner-content');
    const bannerCTA = document.querySelector('.register-banner-cta');
    const bannerImage = document.querySelector('.register-banner-image');
    const pageContent = document.querySelector(
      '.page-content > .element:first-child'
    );

    if (!e.matches) {
      /* eslint-disable */
      bannerContent.style.marginTop &&= '';
      bannerImage.style.height &&= '';
      bannerCTA.style.marginBottom &&= '';
      pageContent.style.paddingTop &&= '';
      /* eslint-enable */

      return;
    }

    if (bannerContent && bannerImage) {
      bannerContent.style.marginTop = `-${bannerContent.clientHeight}px`;
      bannerImage.style.height = `${bannerContent.clientHeight * 2}px`;
    }

    if (bannerCTA && pageContent) {
      bannerCTA.style.marginBottom = `-${bannerCTA.clientHeight}px`;
      pageContent.style.paddingTop = `${bannerCTA.clientHeight + 54}px`;
    }
  };

  window.addEventListener('resize', debounce(setBanner), {
    passive: true
  });

  setBanner();
}

export default registerBanner;
